import React from "react";

export default function CopyStep7() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          7
        </div>
        <h1 className="">
          <b>Pronto!</b> Agora a sua conta de investidor já está criada.
        </h1>
      </div>
      <div className="ml-[42px] flex items-start gap-2.5 flex-wrap">
        <p>
          O próximo passo é realizar um depósito e ativar a MAIA™ na sua conta.
        </p>
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/drNPKC0720161.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
